var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.570312,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#BF3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4974 22.0968C23.5489 22.0833 24.8003 22.1602 26.1646 22.4269C26.1646 22.4269 26.7555 22.549 26.7599 23.1052C26.7599 23.1052 26.7946 24.4392 26.8033 24.6969C26.8033 24.7195 26.8033 24.7376 26.8033 24.7602C26.8033 24.8688 26.8337 25.4114 27.5593 25.8817L30.3749 27.5864C30.5444 27.6904 30.7312 27.7537 30.9267 27.7763C31.1787 27.8035 31.5176 27.7763 31.8218 27.5593C31.8392 27.5457 31.8566 27.5322 31.8739 27.5231C32.013 27.4282 32.7038 26.9488 33.0775 26.4559C33.1731 26.3293 33.247 26.1801 33.2948 26.0264C33.4903 25.4069 33.9335 23.4353 32.2997 21.6989C32.2997 21.6989 31.1874 20.5639 29.8622 19.8766C29.8622 19.8766 27.6984 18.71 25.3303 18.5155C25.326 18.5065 24.1442 18.3437 22.4974 18.3572C20.8506 18.3437 19.6688 18.5065 19.6688 18.5065C17.3008 18.7009 15.1369 19.8676 15.1369 19.8676C13.8074 20.5549 12.6994 21.6899 12.6994 21.6899C11.0657 23.4263 11.5089 25.4023 11.7087 26.0173C11.7565 26.1711 11.8304 26.3158 11.926 26.4469C12.2953 26.9398 12.9905 27.4191 13.1295 27.5141C13.1469 27.5276 13.1643 27.5367 13.1817 27.5502C13.4858 27.7718 13.8247 27.7944 14.0768 27.7673C14.2723 27.7447 14.4591 27.6814 14.6286 27.5774L17.4441 25.8726C18.1654 25.4023 18.2002 24.8597 18.2002 24.7512C18.2002 24.7286 18.2002 24.7105 18.2002 24.6879C18.2045 24.4301 18.2436 23.0962 18.2436 23.0962C18.2436 22.54 18.8389 22.4179 18.8389 22.4179C20.1989 22.1511 21.4546 22.0788 22.5061 22.0878L22.4974 22.0968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/endCall.a2e8a62b2b767f115b75662a865e378c.svg";
export { ForwardRef as ReactComponent };